import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { KeycloakService } from 'keycloak-angular';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private authSrv: AuthService,
        private keycloak: KeycloakService
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.keycloak.getToken().then(token => {
            //console.log('Keycloak token:', token);
        });
        return from(this.keycloak.getToken()).pipe(
            switchMap(token => {
                //console.log('Keycloak token:', token);
                const tokenDevice = this.authSrv.getetDeviceToken();
                if (token || tokenDevice) {
                    const clonedRequest = req.clone({
                        setHeaders: {
                            Authorization: token ? `Bearer ${token}` : '',
                            'x-device-token': tokenDevice ?? '',
                        }
                    });
                    return next.handle(clonedRequest);
                }
                return next.handle(req);
            })
        );
    }
}